import { render, staticRenderFns } from "./RoomLobby.vue?vue&type=template&id=2ce833be&scoped=true&lang=pug&"
import script from "./RoomLobby.vue?vue&type=script&lang=js&"
export * from "./RoomLobby.vue?vue&type=script&lang=js&"
import style0 from "./RoomLobby.vue?vue&type=style&index=0&id=2ce833be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ce833be",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VHover } from 'vuetify/lib/components/VHover';
installComponents(component, {VApp,VAvatar,VCard,VContainer,VHover})
